import React, { useEffect, useState } from "react";
import { bannerImg, star, yellowStar } from "..";
import "../bannerSection/banner.scss";
import Button from "../../assets/common/button/Button"
import IntroForm from "../IntroForm/IntroForm";
import Aos from "aos";

const Banner = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    Aos.init({ duration: 1000});
  }, []);


  return (
    <div className="container">
      <div className="row banner-heading align-items-center">
        <div className="col-auto" data-aos="zoom-in-up">
          <span>Inspire</span>
        </div>
        <div className="col-auto star">
          <img src={yellowStar} alt="star-Img" className="star-Img" />
        </div>
        <div className="col-auto" data-aos="zoom-in-up">
          <span>Innovate</span>
        </div>
        <div className="col-auto star">
          <img src={yellowStar} alt="star-Img" className="star-Img" />
        </div>
        <div className="col-auto" data-aos="zoom-in-up">
          <span>Create</span>
        </div>
      </div>

      <div className="split-line">
        <div className="line"></div>
        <img src={star} alt="star-Img" className="divider-star" />
        <div className="line"></div>
      </div>

      <div className="banner-img">
        <img src={bannerImg} alt="banner-Img" />
        <div className="banner-content">
          <p data-aos="fade-right">Ready to work with us ?</p>
          <Button
          onClick={() => setIsModalOpen(true)}
          text="LET'S TALK" />
        </div>
        <IntroForm isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
      </div>
      </div>
  );
};

export default Banner;
